import api from '../../plugins/api';

// Пачка файлов уходит одним запросом — бэк обрабатывает её как один логический
// импорт: замена сегментов стока (ДЦ + марка) общая на все файлы пачки, а не
// повторная для каждого (иначе файлы с пересекающимися ДЦ+маркой затирали бы
// друг друга)
const uploadStock = (files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));

  return api.post('/api/crm/cars/uploadStock', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export default uploadStock;
